import "react-toastify/dist/ReactToastify.css";

import RootProvider from "./context/RootProvider";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./styles/globalStyles";
import { Outlet } from "react-router-dom";
import theme from "./theme";
import ScrollToTop from "./components/ScrollToTop";
import { ToastContainer } from "react-toastify";

type Props = {};


const App = (props: Props) => {
  return (
    <RootProvider>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <ScrollToTop />
        <Outlet />
        <ToastContainer
          position="top-right"
          autoClose={2000}
          // hideProgressBar={false}
          // newestOnTop={false}
          // closeOnClick
          // rtl={false}
          // pauseOnHover
          // theme="light"
          // style={{ zIndex: theme.zIndices.toast }}
          // progressStyle={{ background: theme.colors.primary }}
        />
      </ThemeProvider>
    </RootProvider>
  );
};

export default App;
